import axios from "axios";
import ApiService from "@/services/api.service";
import { API_URL } from "@/services/config.service";

const state = {
  apps: [],
  selected_app: null,
  loading: false,
  apiUrl: API_URL + "/apps",
  axiosConfig: {
    headers: {
      "Content-Type": "application/json"
    }
  }
};

const getters = {
  allApps: state => state.apps
};

const mutations = {
  setApps: (state, payload) => (state.apps = payload),
  addApp: (state, payload) => state.apps.push(payload),
  msetSelectedApp: (state, payload) => (state.selected_app = payload),
  setLoading: (state, payload) => (state.loading = payload)
};

const actions = {
  afetchApps: async ({ state, commit }) => {
    commit("setLoading", true);
    try {
      const response = await ApiService.get("apps");
      commit("setApps", response.data.apps);
      //return response.data.departed_vessels;
    } catch (error) {
      commit("setApps", []);
    }
    commit("setLoading", false);
  },
  asetSelectedApp: function({ commit }, payload) {
    commit("msetSelectedApp", payload.item);
  }
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
};
